import { useGenericQuery } from '../../../core/api/reactQuery';
import { getCredits } from '../../../core/queries/essays-queries/credits';
import { meEssayStore } from '../stores/meEssayStore';

export function useCredits() {
  const { setCredits } = meEssayStore()
  const {
    data,
    isError,
    error,
    isPending
  } = useGenericQuery(['credits'], () => getCredits(), setCredits);

  return {
    data,
    isError,
    isPending,
    error,
  }
}
